import { render, staticRenderFns } from "./RecipesState.vue?vue&type=template&id=1cadbd8c"
import script from "./RecipesState.vue?vue&type=script&lang=js"
export * from "./RecipesState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports